import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Modal, Tab, Tabs, Button, Dropdown, DropdownButton, Row, Col } from 'react-bootstrap';
import 'alertifyjs/build/css/alertify.css';
import { LoaderLoader } from '../../../utils/CommonLibrary';
import Line from '../graphs/Line';
import Pie from '../graphs/Pie';
import MetricsFreeTextInsights from './MetricsFreeTextInsights';
import { fetch_vital_graph } from '../services/Service';
import Generic from '../../../RPMDashboard/components/Graphs/Generic';


const MetricsInsights = (props) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [vitalGraphs, setVitalGraphs] = useState({}); 
    useEffect(() => { 
        fetchMetricsGraph(); 
    }, []); 


    // fetch the graph for teh metrics
    async function fetchMetricsGraph(){
        setLoading(true); 
        // fetch the graph for the each metrics
        let metrics = props.metricsInsightsArr.metrics; 
        if(metrics.length === 0) return; 

        let vitalsGraphData = {}; 

        metrics.forEach(async (metric) => {            
            // if the metric's input type is not numeric, cant create a line graph
            if (metric.inputType !== "numeric") return; 
            
            try{
                let response = await fetch_vital_graph({userId: props.userId, metricsId: metric.metricsId}); 
                if(response.data.code === 200){
                    const graphData = response.data?.data?.data; 
                    
                    let lastIndex = graphData.length -1 ; 
                    let newVitalsData = {
                        title: metric.metricsName,
                        unit: metric.unit, 
                        current: graphData.length > 0 ? graphData[lastIndex].paramVal.toString(): 0,
                        currentObservation: graphData.length > 0 ? graphData[lastIndex]?.observation.observation || "": "",
                        history: graphData.map(item => ({
                            date: item.createdTime,
                            value: parseFloat(item.paramVal)
                        }))
                    };


                    
                    vitalsGraphData[metric.keyword] = newVitalsData; 
                    setVitalGraphs((prev) => { 
                        return { 
                            ...prev, 
                            [metric.keyword] : newVitalsData
                        }
                    })
                }

            }catch(e){  
                console.log(e); 
            }finally{ 
                setLoading(false); 
            }
        });  
        
    }

    return (
        <>
            <LoaderLoader isLoading={loading} />
            <Modal id="metricsInsights" show={props.showMetricsInsightsModal} centered onHide={() => props.setShowMetricsInsightsModal(false)} size="xl" backdrop="static" keyboard={false} fullscreen={false}>
                <Modal.Header closeButton>
                    <h1 className='modal-title'>Insights - {props.metricsInsightsArr.conditionName}</h1>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        {
                            props.metricsInsightsArr.metrics.map((item, index) => {
                                return <>

                                    <Col lg="12" className=' mb-4'>
                                        
                                        { 
                                            vitalGraphs[item.keyword] ? 
                                            <div>
                                                <Generic data={vitalGraphs[item.keyword]} /> 
                                            </div>: 

                                            <div className='dashboard-graph-box card-task p-2 ps-1'>
                                                {
                                                    item.inputType == "numeric" &&
                                                    <Line lineGraphTitle={item.metricsName} lineGraphType="metrics_insights_numeric_data" userId={props.userId} refreshVar={props.refreshVar} metricsId={item.metricsId} />
                                                }
                                                {
                                                    item.inputType == "select" &&
                                                    <Pie pieGraphTitle={item.metricsName} pieGraphType="metrics_insights_select_data" userId={props.userId} refreshVar={props.refreshVar} metricsId={item.metricsId} />
                                                }
                                                {
                                                    item.inputType == "freetext" &&
                                                    <MetricsFreeTextInsights userId={props.userId} metricsId={item.metricsId} metricsName={item.metricsName} />
                                                }
                                            </div>
                                        }

                                    </Col>

                                </>
                            })
                        }
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MetricsInsights